<template>
    <FlexCenter class="pt-10">
      <router-link to="/">
        <img src="../assets/brand.png">
      </router-link>
    </FlexCenter>
</template>

<script lang="ts">
import FlexCenter from './FlexCenter.vue';

export default ({
  components: {
    FlexCenter
  }
});
</script>